function SWITCH({ match, children, fallback = null }) {
	const found = children.find(({ props }) => props?.case === match);
	return found || fallback;
}

export default SWITCH;
